import React, { useEffect } from 'react';
import { Grid, Link, Typography, useMediaQuery } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Trans } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import useMedian from 'hooks/useMedian';
import HeandJlivePnone38 from 'components/svg/heandJlivePhone-38.svg';
import HeandJlivePnone54 from 'components/svg/heandJlivePhone-54.svg';
import IosBadge32 from 'components/svg/Download_on_the_App_Store_Badge_US-UK_32.svg';
import IosBadge36 from 'components/svg/Download_on_the_App_Store_Badge_US-UK_36.svg';
import GoogleBadge32 from 'components/svg/Google_Play_Store_badge_32.svg';
import GoogleBadge36 from 'components/svg/Google_Play_Store_badge_36.svg';
import { getWithExpiry, setWithExpiry } from './utils';

const useStyles = makeStyles()(() => ({
  main: {
    backgroundColor: '#F7F7F7',
    height: 48,
    '@media (max-width: 1080px)': {
      height: 64,
    },
  },
  image: {
    width: '100%',
    height: 'auto',
  },
  image1Container: {
    width: 60,
    paddingTop: 10,
    '@media (max-width: 1080px)': {
      width: 82,
    },
  },
  image2Container: {
    marginLeft: 24,
    marginTop: 8,
    '@media (max-width: 1080px)': {
      marginLeft: 16,
      marginTop: 12,
    },
  },
  image3Container: {
    marginTop: 8,
    marginLeft: 8,
    '@media (max-width: 1080px)': {
      width: 122,
      marginTop: 12,
    },
  },
  new: {
    padding: '0 8px',
    paddingBottom: 4,
    backgroundColor: '#A9DED7',
    borderRadius: 16,
  },
  textContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    height: 48,
    '@media (max-width: 1080px)': {
      height: 64,
    },
  },
  close: {
    position: 'absolute',
    right: 16,
    top: 12,
    cursor: 'pointer',
    fill: '#7B8BAD',
    '@media (max-width: 1080px)': {
      top: 18,
    },
  },
}));

const TWO_WEEKS = 2 * 7 * 24 * 60 * 60 * 1000;

const MobileAppsHeader: React.FC = () => {
  const { classes } = useStyles();
  const { isMedian } = useMedian();
  const [show, setShow] = React.useState(false);
  const less1080 = useMediaQuery('(max-width: 1080px)');

  useEffect(() => {
    const isBannerHidden = getWithExpiry('mobileAppsBannerHidden');
    setShow(!isBannerHidden && !isMedian);
  }, [isMedian]);

  const handleClose = () => {
    setWithExpiry('mobileAppsBannerHidden', 'true', TWO_WEEKS);
    window.dispatchEvent(new Event('storage'));

    setShow(false);
  };

  if (!show) return;

  return (
    <Grid className={classes.main} justifyContent="center" container>
      <Grid item className={classes.image1Container}>
        {less1080 ? <HeandJlivePnone54 /> : <HeandJlivePnone38 />}
      </Grid>
      <Grid item className={classes.textContainer}>
        <Typography variant="h6">
          <Trans i18nKey="headers.mobileApps.title" ns="public">
            Download our <span className={classes.new}>new</span> iOS or Android app
          </Trans>
        </Typography>
      </Grid>
      <Grid item className={classes.image2Container}>
        <Link
          // eslint-disable-next-line max-len
          href="https://apps.apple.com/app/apple-store/id6736647530?pt=127356794&ct=Jlive%20Website&mt=8?utm_source=jlivewebsite-header&utm_medium=banner&utm_campaign=ios_launch"
          target="_blank"
          underline="none"
        >
          {less1080 ? <IosBadge36 /> : <IosBadge32 />}
        </Link>
      </Grid>
      <Grid item className={classes.image3Container}>
        <Link
          // eslint-disable-next-line max-len
          href="https://play.google.com/store/apps/details?id=co.median.android.erqlzd"
          target="_blank"
          underline="none"
        >
          {less1080 ? <GoogleBadge36 /> : <GoogleBadge32 />}
        </Link>
      </Grid>
      <div>
        <CloseIcon className={classes.close} onClick={handleClose} />
      </div>
    </Grid>
  );
};

export default MobileAppsHeader;
